const AIRSPACE_CDN_URL_REGEX = /https:\/\/([a-z0-9-]+)\.airspace-cdn\.cbsivideo\.com(\/[^\s"'<>]*)?/gi;

export const rewriteAirspaceCdnUrls = (text: string): string =>
  text.replace(
    new RegExp(AIRSPACE_CDN_URL_REGEX),
    (_match, subdomain: string, pathAndQuery = '') => `/airspace-proxy/${subdomain}${pathAndQuery}`,
  );
